import React from 'react';
import './DocumentChatLayout.css';

export interface DocumentChatLayoutProps {
  thread: React.ReactNode;
  composer: React.ReactNode;
}

/** Thread + composer column used by PDF checklist document chats. */
export default function DocumentChatLayout({ thread, composer }: DocumentChatLayoutProps) {
  return (
    <div className="wr-chat">
      <div className="wr-chat__thread">{thread}</div>
      <div className="wr-chat__composer-area">{composer}</div>
    </div>
  );
}
